export async function generateSha256Hash(printedQuery: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(printedQuery);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
